import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, KeepAlive as _KeepAlive, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "pay-page"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_PayList = _resolveComponent("PayList");
  const _component_PayListOld = _resolveComponent("PayListOld");
  const _component_FooterPage = _resolveComponent("FooterPage");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(), _createBlock(_KeepAlive, null, [$setup.isOld == 'open' ? (_openBlock(), _createBlock(_component_PayList, {
    key: 0,
    uiType: $setup.isOld
  }, null, 8, ["uiType"])) : _createCommentVNode("", true)], 1024)), $setup.isOld == 'close' ? (_openBlock(), _createBlock(_component_PayListOld, {
    key: 0,
    uiType: $setup.isOld
  }, null, 8, ["uiType"])) : _createCommentVNode("", true), $setup.isOld ? (_openBlock(), _createBlock(_component_FooterPage, {
    key: 1
  })) : _createCommentVNode("", true)]);
}